import { FC, PropsWithChildren, useRef } from 'react';

import { usePage } from '@inertiajs/react';

import Header, { HeaderRef } from '../components/Header';
import { MobileBottomNav } from '../components/MobileBottomNav';
import { SeoHead } from '../components/shared/SeoHead';
import { CartProvider } from '../context/cart-context';
import { ProfileInfo } from '../pages/Users/ProfileInfo';
import { CurrentUser, PublicUser } from '../types';
import { Metadata, StructuredData } from '../types/shared';

type PageProps = {
    user: PublicUser;
    metadata: Metadata;
    structuredData?: StructuredData | null;
    currentUser: CurrentUser | null;
    newNotificationPresent?: boolean;
};

const Users: FC<PropsWithChildren> = ({ children }) => {
    const {
        user,
        metadata,
        structuredData,
        currentUser,
        newNotificationPresent,
    } = usePage<PageProps>().props;

    const headerRef = useRef<HeaderRef>(null);

    return (
        <CartProvider>
            <SeoHead metadata={metadata} structuredData={structuredData} />

            <div className="flex min-h-screen flex-col">
                <Header ref={headerRef} />

                <div className="flex min-h-screen flex-col">
                    <main className="flex-1 pt-10">
                        <ProfileInfo user={user} />

                        {children}
                    </main>
                </div>

                <MobileBottomNav
                    currentUser={currentUser}
                    onSearchClick={() => headerRef.current?.focusSearch()}
                    newNotificationPresent={newNotificationPresent}
                />
            </div>
        </CartProvider>
    );
};

export default Users;
